module.exports = __webpack_public_path__ + "static/media/bridge_3-new.6cf97537.svg";